import clsx from 'clsx'

export function HeartIcon({ className = '', onClick }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="27"
      viewBox="0 0 29 27"
      fill="currentColor"
      className={clsx('text-[#5B5B5B] cursor-pointer', className)}
      onClick={onClick}
      role="button"
      aria-label="הוספה למועדפים"
      title="אהבתי"
    >
      <path d="M28.9175 7.94377C28.9175 3.98045 25.7046 0.767578 21.7413 0.767578C18.4831 0.767578 15.7338 2.93974 14.8581 5.91439C13.9824 2.93987 11.2334 0.767766 7.97532 0.767578C0.00997031 0.767015 -1.36365 12.1588 4.62267 16.0572C6.74029 17.4362 8.93578 18.7781 10.8718 20.4473C11.7942 21.2424 12.6491 22.1202 13.3481 23.1205C13.7134 23.6432 14.5173 25.1952 14.8676 26.2329C19.9517 22.5911 25.4078 18.4201 27.9244 12.4652C28.5287 11.0352 28.9175 9.50276 28.9175 7.94377Z" />
    </svg>
  )
}
